import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import BlackHole from "@/studio/components/BlackHole";

const ease = [0.16, 1, 0.3, 1];

function Word({ children, from }) {
  return (
    <span className="reveal-mask block">
      <motion.span
        className="block"
        initial={{ x: from, opacity: 0 }}
        whileInView={{ x: 0, opacity: 1 }}
        viewport={{ once: true, margin: "-15%" }}
        transition={{ duration: 1, ease }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export default function Transition() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["10%", "-10%"]);
  const scale = useTransform(scrollYProgress, [0, 0.5, 1], [0.86, 1.08, 0.92]);

  return (
    <section
      ref={ref}
      className="relative flex min-h-[100svh] flex-col items-center justify-center overflow-hidden bg-[var(--paper)] py-24"
    >
      <div className="relative z-10 mx-auto flex w-full max-w-[1500px] flex-col items-center px-5 text-center">
        <h2 className="ff-display text-[15vw] font-extrabold leading-[0.86] tracking-tighter md:text-[9vw]">
          <Word from="-12%">HIGH-END</Word>
        </h2>

        {/* black hole sits IN-FLOW between the two words */}
        <motion.div
          style={{ y, scale }}
          className="relative my-2 h-[38vh] w-[60vh] max-w-[560px]"
        >
          <BlackHole className="h-full w-full" glow parallax={10} />
        </motion.div>

        <h2 className="ff-display text-[15vw] font-extrabold leading-[0.86] tracking-tighter md:text-[9vw]">
          <Word from="12%">EXECUTION</Word>
        </h2>

        {/* small editorial mark — quiet, no animation */}
        <p className="ff-ui mt-10 max-w-md text-[13px] leading-relaxed text-[var(--ink-soft)] md:mt-14">
          Designed without compromise. Engineered to remain.
        </p>
      </div>
    </section>
  );
}
